import {load} from '@shopify/theme-sections';
import '../../styles/layouts/theme.scss';
import 'preact/devtools';
import 'lazyvids';
import 'dragscroll';

import accordionsInit from '../components/accordions';
import fadeInPage from '../components/fader';
import lazyImageLoader from '../utils/lazy-image-loader';
import clickFix from '../components/dragscroll-click-fix';

import '../components/web-vitals';
import '../sections/announcement';
import '../sections/terms-banner';
import '../sections/header';
import '../sections/popup';

document.addEventListener('DOMContentLoaded', () => {
  load('*');
  // Conditionally loads lazySizes for Safari
  lazyImageLoader();
  accordionsInit();
  fadeInPage();
  clickFix();

  /**
   * Dynamic imports are used to reduce main thread blocking time
   * during page load. Webpack handles code splitting these modules.
   */

  /**
   * Feature detect scroll-behavior CSS property, and dynamically import
   * the polyfill for unsupported browsers (Safari).
   */
  if (!('scrollBehavior' in document.documentElement.style)) {
    const setScrollBehavior = () => {
      /**
       * Inline style must be added this way for two reasons:
       * 1. The package does not polyfill CSS, and cannot detect scroll-behavior
       * set in a stylesheet.
       *
       * 2. Safari doesn't allow setting scroll-behavior as an inline style
       * via Element.style.scrollBehavior = 'smooth' as it's considered invalid.
       */
      const documentStyles = document.documentElement.getAttribute('style') ?? '';
      const newDocumentStyles = `scroll-behavior: smooth; ${documentStyles}`;
      document.documentElement.setAttribute('style', newDocumentStyles);
    };

    const url = window?.theme?.urlPatterns?.assetUrl?.replace('_name_.js', 'scroll-behavior-polyfill.js');
    if (url) {
      const script = document.createElement('script');
      script.src = url;
      script.onload = setScrollBehavior;
      document.head.appendChild(script);
    }
  }

  const rteIframes = document.querySelectorAll(
    '.rte iframe[src*="youtube.com/embed"], .rte iframe[src*="player.vimeo"]',
  );
  rteIframes.forEach((el) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte__video-wrapper');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  });

  const rteTables = document.querySelectorAll('.rte table');
  rteTables.forEach((el) => {
    const wrapper = document.createElement('div');
    wrapper.classList.add('rte__table-wrapper');
    el.parentNode.insertBefore(wrapper, el);
    wrapper.appendChild(el);
  });

  /**
   * Preact App entry point
   */
  import(/* webpackChunkName: 'app' */ '../../../app')
    .then((module) => module.default())
    .catch((error) => window.console.error('Could not load App module', error));
});
